
import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const FormLoginPage = lazy(() => import('../pages/form-login/page'));
const FormChangePasswordPage = lazy(() => import('../pages/form-change-password/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/form',
    element: <Navigate to="/" replace />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/form-login',
    element: <FormLoginPage />,
  },
  {
    path: '/form-change-password',
    element: <FormChangePasswordPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
